import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth.service';
import { GroupsService } from 'src/app/views/groups/groups.service';

@Component({
  selector: 'app-user-group-list',
  templateUrl: './user-group-list.component.html',
  styleUrls: ['./user-group-list.component.css'],
  standalone: false,
})
export class UserGroupListComponent implements OnInit, OnDestroy {
  // TODO mettre cette composante dans le todo config

  groupList = [];
  @Output() onSelectionChange = new EventEmitter<any>();
  translateSub;
  selectedGroup = 'None';
  i18n = {};
  i18nList = ['Global.None'];

  constructor(
    private groupService: GroupsService,
    private translate: TranslateService,
    private authService: AuthService
  ) {
    this.translateSub = this.translate.onLangChange.subscribe((res) => {
      this.getGroupNames();
      this.translateNames();
    });
  }

  ngOnInit() {
    this.getUserGroups();
  }

  ngOnDestroy() {
    this.translateSub.unsubscribe();
  }

  translateNames() {
    this.translate.get(this.i18nList).subscribe((i18n) => {
      this.i18n = i18n;
      if (this.groupList.length > 1) {
        const index = this.groupList.findIndex((e) => e._id == 'None');
        if (index != -1) {
          this.groupList[index].name = this.i18n['Global.None'];
        }
      }
    });
  }

  getGroupNames() {
    // this.groupList = this.groupList.filter(group => group.__name)
    this.groupList = this.groupList.map((group) => {
      if (group._id == this.authService.userInfo()._id) {
        group.name = this.authService.userInfo().fullName;
      }
      if (group.__name) {
        group.name = group.__name.editions.find((edition) => edition.language == this.translate.currentLang).content;
      }
      return group;
    });
  }

  getUserGroups() {
    const userGroups = localStorage.getItem('userGroups');
    const onGroupsListRecieved = (res) => {
      const first = { _id: 'None', name: 'None' };
      this.groupList = [first];
      this.groupList = this.groupList.concat(res || []);
      this.getGroupNames();
      this.translateNames();
    };
    if (userGroups) {
      onGroupsListRecieved(JSON.parse(userGroups));
    } else {
      this.groupService.getUserGroups().subscribe(onGroupsListRecieved);
    }
  }
}
